<template>
	<g :transform="'translate(' + x + ',' + y + ')'">
		<rect class="backRect" :x="x + depthOffset.x - x" :y="y - depthOffset.y - y" :width="width" :height="height" />
		
		<g :transform="'translate(3, -26)'">
			<g v-for="(p, index) in parts" :key="index" :transform="'translate(' + (index * (width/parts - (!isFirst ? -2 : 0)) ) + ', 0)'">
				<path d="M43.9772 0.0391846H43.26L1.43381 24.9999H2.15097L43.9772 0.0391846Z" fill="#EBECEC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M5.01723 24.9717C4.06715 24.9717 3.11707 24.9717 2.16699 24.9717L43.9705 0C44.9205 0 45.8706 0 46.8207 0L5.01723 24.9717Z" fill="#C5C6C6"/>
				<path d="M47.5629 0.0391846H46.8457L5.0195 24.9999H5.73666L47.5629 0.0391846Z" fill="#B2B3B3"/>
				<path d="M85.8307 0.0391846H85.1135L43.2873 24.9999H44.0045L85.8307 0.0391846Z" fill="#EBECEC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M46.9096 24.9717C45.9596 24.9717 44.9364 24.9717 43.9863 24.9717L85.8629 0C86.813 0 87.763 0 88.7131 0L46.9096 24.9717Z" fill="#C5C6C6"/>
				<path d="M89.4161 0.0391846H88.699L46.8728 24.9999H47.5899L89.4161 0.0391846Z" fill="#B2B3B3"/>
				<path d="M55.9315 0.0391846H55.2144L13.3882 24.9999H14.1053L55.9315 0.0391846Z" fill="#EBECEC"/>
				<path d="M55.931 0.0391846H56.6482L14.822 24.9999H14.1048L55.931 0.0391846Z" fill="#FEFEFE"/>
				<path d="M56.6486 0.0391846H57.3657L15.5395 24.9999H14.8224L56.6486 0.0391846Z" fill="#C5C6C6"/>
				<path d="M58.0829 0.0391846H57.3657L15.5395 24.9999H16.2567L58.0829 0.0391846Z" fill="#D9DADA"/>
				<path d="M66.2811 0.0391846H65.564L23.7378 24.9999H24.4549L66.2811 0.0391846Z" fill="#EBECEC"/>
				<path d="M66.2814 0.0391846H66.9985L25.1723 24.9999H24.4552L66.2814 0.0391846Z" fill="#FEFEFE"/>
				<path d="M66.9984 0.0391846H67.7156L25.8894 24.9999H25.1722L66.9984 0.0391846Z" fill="#C5C6C6"/>
				<path d="M68.4327 0.0391846H67.7156L25.8894 24.9999H26.6065L68.4327 0.0391846Z" fill="#D9DADA"/>
				<path d="M76.6312 0.0391846H75.9141L34.0879 24.9999H34.805L76.6312 0.0391846Z" fill="#EBECEC"/>
				<path d="M76.6315 0.0391846H77.3486L35.5224 24.9999H34.8053L76.6315 0.0391846Z" fill="#FEFEFE"/>
				<path d="M77.3483 0.0391846H78.0654L36.2392 24.9999H35.5221L77.3483 0.0391846Z" fill="#C5C6C6"/>
				<path d="M78.7826 0.0391846H78.0654L36.2392 24.9999H36.9564L78.7826 0.0391846Z" fill="#D9DADA"/>
				<path d="M8.07036 20.2507L8.76978 19.837L56.3143 19.837L55.6149 20.2507L8.07036 20.2507Z" fill="#EBECEC"/>
				<path d="M7.37139 20.664L8.0708 20.2504L55.6154 20.2504L54.916 20.664L7.37139 20.664Z" fill="#FEFEFE"/>
				<path d="M7.37178 20.664L6.67236 21.0776L54.2169 21.0776L54.9163 20.664L7.37178 20.664Z" fill="#C5C6C6"/>
				<path d="M5.97295 21.4913L6.67236 21.0776L54.2169 21.0776L53.5175 21.4913L5.97295 21.4913Z" fill="#D9DADA"/>
				<path d="M15.5516 15.9026L16.251 15.489L63.7955 15.489L63.0961 15.9026L15.5516 15.9026Z" fill="#EBECEC"/>
				<path d="M14.8526 16.3162L15.552 15.9026L63.0966 15.9026L62.3972 16.3162L14.8526 16.3162Z" fill="#FEFEFE"/>
				<path d="M14.853 16.3162L14.1536 16.7299L61.6981 16.7299L62.3975 16.3162L14.853 16.3162Z" fill="#C5C6C6"/>
				<path d="M13.4542 17.1435L14.1536 16.7299L61.6981 16.7299L60.9987 17.1435L13.4542 17.1435Z" fill="#D9DADA"/>
				<path d="M23.0237 11.555L23.7231 11.1414L71.2677 11.1414L70.5683 11.555L23.0237 11.555Z" fill="#EBECEC"/>
				<path d="M22.3248 11.9683L23.0242 11.5547L70.5687 11.5547L69.8693 11.9683L22.3248 11.9683Z" fill="#FEFEFE"/>
				<path d="M22.3251 11.9685L21.6257 12.3821L69.1703 12.3821L69.8697 11.9685L22.3251 11.9685Z" fill="#C5C6C6"/>
				<path d="M20.9263 12.7957L21.6257 12.3821L69.1703 12.3821L68.4709 12.7957L20.9263 12.7957Z" fill="#D9DADA"/>
				<path d="M30.4966 7.20707L31.196 6.79346L78.7406 6.79346L78.0412 7.20707L30.4966 7.20707Z" fill="#EBECEC"/>
				<path d="M29.7974 7.62065L30.4968 7.20703L78.0414 7.20703L77.342 7.62065L29.7974 7.62065Z" fill="#FEFEFE"/>
				<path d="M29.7978 7.62044L29.0984 8.03406L76.643 8.03406L77.3424 7.62044L29.7978 7.62044Z" fill="#C5C6C6"/>
				<path d="M28.399 8.44767L29.0984 8.03406L76.643 8.03406L75.9435 8.44767L28.399 8.44767Z" fill="#D9DADA"/>
				<path d="M37.9688 2.91069L38.6682 2.49707L86.2128 2.49707L85.5134 2.91069L37.9688 2.91069Z" fill="#EBECEC"/>
				<path d="M37.2696 3.32426L37.969 2.91064L85.5136 2.91064L84.8141 3.32426L37.2696 3.32426Z" fill="#FEFEFE"/>
				<path d="M37.27 3.32418L36.5706 3.73779L84.1151 3.73779L84.8145 3.32418L37.27 3.32418Z" fill="#C5C6C6"/>
				<path d="M35.8711 4.15141L36.5706 3.73779L84.1151 3.73779L83.4157 4.15141L35.8711 4.15141Z" fill="#D9DADA"/>
				<path d="M89.8492 0.0391846H89.1321L47.3059 24.9999H48.023L89.8492 0.0391846Z" fill="#EBECEC"/>
				<path d="M89.849 0.0391846H90.5662L48.74 24.9999H48.0228L89.849 0.0391846Z" fill="#FEFEFE"/>
				<path d="M90.5658 0.0391846H91.283L49.4568 24.9999H48.7396L90.5658 0.0391846Z" fill="#C5C6C6"/>
				<path d="M92.0001 0.0391846H91.283L49.4568 24.9999H50.1739L92.0001 0.0391846Z" fill="#D9DADA"/>
				<path d="M42.5433 0.0391846H41.8262L-2.66079e-05 24.9999H0.717131L42.5433 0.0391846Z" fill="#EBECEC"/>
				<path d="M42.5429 0.0391846H43.26L1.43381 24.9999H0.716653L42.5429 0.0391846Z" fill="#FEFEFE"/>
				<path d="M43.2599 0.0391846H43.9771L2.15085 24.9999H1.43369L43.2599 0.0391846Z" fill="#C5C6C6"/>
				<path d="M44.6942 0.0391846H43.9771L2.15085 24.9999H2.86801L44.6942 0.0391846Z" fill="#D9DADA"/>
			</g>
		</g>

		<polygon class="topEdge" :points="topEdgeBack" />
		<polygon class="topEdge" :points="topEdgeFront" />

		<line class="topLine" v-for="line in topLines" :x1="line.x1" :y1="line.y1" :x2="line.x2" :y2="line.y2" />
		<rect class="deepRect" :x="x - x" :y="y + 2.3 - y" :width="width" :height="6.3" />
		<rect class="frontRect" :x="x - x" :y="y - y" :width="width" :height="height" />

		<rect class="bottomEdge" :x="x - x" :y="y + 2 - y" :width="width" :height="0.3" />
		<rect class="topEdge" :x="x - x" :y="y + 8 - y" :width="width" :height="1" />
	</g>
</template>

<script>
	export default {
		name: 'ShelfGrid800',
		props: {
			x: Number,
			y: Number,
			width: Number,
			height: {
				type: Number,
				default: 11,
			},
			parts: {
				type: Number,
				default: 6,
			},
			rackOffset: Object,
			depthOffset: Object,
			isFirst: Boolean,
		},
		computed: {
			topLines() {
				const lines = [];
				const partWidth = this.width / this.parts;

				for (let i = 1; i < this.parts; i++) {
					lines.push({
						x1: 0 + partWidth * i,
						y1: 0,
						x2: 0 + this.depthOffset.x + partWidth * i,
						y2: 0 - this.depthOffset.y,
					});
				}

				return lines;
			},
			topEdgeBack() {
				return `${0 + this.depthOffset.x},${0 - this.depthOffset.y}
						${0 + this.width + this.depthOffset.x},${0 - this.depthOffset.y}
						${0 + this.width + this.depthOffset.x - this.rackOffset.x / 2},${0 - this.depthOffset.y + this.rackOffset.y / 2}
						${0 + this.depthOffset.x - this.rackOffset.x / 2},${0 - this.depthOffset.y + this.rackOffset.y / 2}`;
			},
			topEdgeFront() {
				return `0,0
						${0 + this.width},0
						${0 + this.width + this.rackOffset.x / 2},${0 - this.rackOffset.y / 2}
						${0 + this.rackOffset.x / 2},${0 - this.rackOffset.y / 2}`;
			},
		},
	};
</script>

<style scoped>
	.topPolygon {
		fill: #DCDDDE;
	}
	.rightPolygon {
		fill: #C4C6C8;
	}
	.frontRect {
		fill:#DCDDDE;
	}
	.backRect {
		fill:#9FA1A4;
	}
	.topEdge {
		fill: #EFEFF0;
	}
	.topLine {
		stroke: #BABCBE;
		stroke-width: 0.4;
	}
	.bottomEdge {
		fill: #AFB1B4;
	}
	.deepRect {
		fill: #D6D6D6;
	}
	.deepPolygon {
		fill: #B8B8B8;
	}
</style>